import { Options as HighchartsOptions, XAxisCurrentDateIndicatorLabelOptions, XAxisOptions } from 'highcharts';

import { STATIC_ELEMENT_HEIGHT, STATIC_POINT_HEIGHT } from '../../constants';
import { CHART_BOTTOM_MARGIN, MIN_15, MIN_1, ONE_HOUR } from '../Scheduling/config';

export const CURRENT_TIME_INDICATOR_MARGIN = 55;

export const ganttChartOptions: HighchartsOptions = {
  credits: {
    enabled: false,
  },
  exporting: {
    enabled: false,
  },
  chart: {
    animation: false,
    height: 295,
    marginBottom: CHART_BOTTOM_MARGIN,
    resetZoomButton: {
      position: {
        y: 5,
      },
      theme: {
        fill: '#fff',
        style: {
          fontWeight: '500',
        },
      },
    },
    spacingBottom: 0,
    spacingLeft: 0,
    spacingRight: 0,
    spacingTop: CURRENT_TIME_INDICATOR_MARGIN, // adding space for current time indicator
    style: {
      fontFamily: 'Roboto, sans-serif',
    },
    zoomType: 'x',
  },
  plotOptions: {
    gantt: {
      borderRadius: 2,
      pointWidth: STATIC_POINT_HEIGHT,
      minPointLength: 2,
      states: {
        inactive: {
          animation: {
            duration: 0,
          },
          opacity: 1,
        },
        hover: {
          enabled: false,
        },
        normal: {
          animation: false,
        },
      },
    },
  },
  tooltip: {
    backgroundColor: '#fff',
    borderWidth: 0,
    outside: true,
    padding: 0,
    shadow: false,
    shape: 'square',
    style: { width: 2000 }, // Prevent cropping when chart contains very few values (not being full-size rendered)
    useHTML: true,
  },
  xAxis: [
    {
      animation: false,
      endOnTick: true,
      className: 'zoom-xAxis-minutes',
      currentDateIndicator: {
        className: 'real-time-adherence__gantt-chart__current-time-indicator',
        width: 1,
        color: '#2F80ED',
        label: {
          align: 'center',
          className: 'real-time-adherence__gantt-chart__current-time-indicator-label',
          x: 0,
          style: {
            fontSize: '14px',
          },
          useHTML: true,
          textAlign: 'center',
          verticalAlign: 'top',
          y: -140,
        } as XAxisCurrentDateIndicatorLabelOptions,
        zIndex: 10000,
        id: 'current-time-indicator',
      },
      grid: {
        borderColor: '#fff',
        borderWidth: 2,
      },
      id: 'x-axis-minutes',
      labels: {
        align: 'left',
        overflow: 'allow',
        style: { color: '#3a3c3e', fontSize: '12px', fontWeight: '500' },
        x: 10,
      },
      minRange: MIN_1 * 14,
      showEmpty: false,
      startOnTick: true,
      tickInterval: MIN_15,
      type: 'datetime',
    },
    {
      className: 'zoom-xAxis-hours',
      currentDateIndicator: false,
      endOnTick: true,
      grid: {
        borderColor: '#fff',
        borderWidth: 2,
      },
      id: 'x-axis-hours',
      labels: {
        align: 'left',
        style: {
          color: '#3a3c3e',
          fontSize: '16px',
          fontWeight: '500',
        },
        x: 10,
      },
      linkedTo: 0,
      minRange: MIN_1 * 14,
      showEmpty: false,
      startOnTick: true,
      tickInterval: ONE_HOUR,
      type: 'datetime',
    },
  ] as XAxisOptions[],
  yAxis: [
    {
      categories: [],
      grid: {
        enabled: false,
      },
      gridLineColor: '#fff',
      gridLineWidth: 0,
      labels: {
        enabled: false,
      },
      max: 2,
      min: 0,
      staticScale: STATIC_ELEMENT_HEIGHT,
      title: {
        text: '',
      },
    },
  ],
};
